 
export class OpgaveListItem {
        public id: string;
        public opgavepakkeId: string;
        public titel: string;
        public createdDate: Date;
        public lastChangedDate: Date;
        public aktiv: boolean;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/OpgaveListItem.ts